// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"5589e8d7","361":"af612b8f","501":"36819056","586":"925a0650","716":"dbcd96f5","923":"d0475a44"}[chunkId] + ".chunk.js";
};